module.exports = require("ms");


//////////////////
// WEBPACK FOOTER
// external "ms"
// module id = 6
// module chunks = 0